import { render } from "./SiteNotes.vue?vue&type=template&id=da30a8c2"
import script from "./SiteNotes.vue?vue&type=script&lang=js"
export * from "./SiteNotes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\s.arshad\\Documents\\GitHub\\link-portal\\link\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__